import { Content } from '@prismicio/client';

import { AutoGrid, Box } from '@preventx/oxygen';

// Components
import { DisplayImage } from './DisplayImage';

type ImagesProps = {
  primary: Content.ImageSliceWithManyImagesPrimary;
};

export const Images = ({ primary }: ImagesProps) => {
  const { enable_grid } = primary;

  return (
    <>
      {enable_grid && (
        <AutoGrid component="div">
          {(primary.images ?? []).map((item) => (
            <DisplayImage
              image={item.image}
              caption={item.caption}
              widthOverride={item.width_override}
              heightOverride={item.height_override}
              key={`images-container-${item.image.id}`}
            />
          ))}
        </AutoGrid>
      )}

      {!enable_grid && (
        <Box component="div">
          {(primary.images ?? []).map((item) => (
            <DisplayImage
              image={item.image}
              caption={item.caption}
              widthOverride={item.width_override}
              heightOverride={item.height_override}
              key={`images-container-${item.image.id}`}
            />
          ))}
        </Box>
      )}
    </>
  );
};
